import { TeachingLoadReportType } from '@bp/planung-graphql-types';

/**
 * Report-Typen, für die das Backend die `TeachingLoadReportConfig` auswertet.
 *
 * Phase 1 sind die PDF-Reports. Excel-, Berlin-Excel- und Leliste-Exporte laufen über
 * eine eigene Route und berücksichtigen die Konfiguration noch nicht.
 */
const CONFIGURABLE_TYPES: TeachingLoadReportType[] = [
  TeachingLoadReportType.PlanSingleTeacher,
  TeachingLoadReportType.CurrentSingleTeacher,
  TeachingLoadReportType.PlanOverview,
  TeachingLoadReportType.CurrentOverview,
  TeachingLoadReportType.PlanSubjectGroup,
  TeachingLoadReportType.CurrentSubjectGroup,
  TeachingLoadReportType.PlanKeyFigures,
  TeachingLoadReportType.CurrentKeyFigures,
];

export const supportsConfiguration = (subType: TeachingLoadReportType): boolean => CONFIGURABLE_TYPES.includes(subType);
